import React, { useCallback } from "react";
import { useField } from "formik";
import { Checkbox } from "@design-system/Checkbox/Checkbox";

export const ExcludeSplitTransactionsCheckbox: React.FC = () => {
    const [field, , helpers] = useField<boolean>("excludeSplitTransactions");

    const toggle = useCallback(() => {
        helpers.setValue(!field.value);
    }, [field.value, helpers]);

    return (
        <Checkbox
            checked={field.value}
            onCheckedChange={toggle}
            label="Exclude transactions that are currently split"
        />
    );
};
